<template>
    <div class="filterContent">
        <div>
            <div class="flex1 text-align-left">
                <span class="model_title">意见与建议<span class="require">*</span></span>
            </div>
            <div class="model_content textArea">
                <textarea v-on:input="changeText"/>
            </div>
            <!-- 图片显示区域 -->
            <div v-if="imgUrl !== ''" class="feedBackImg">
                <img :src="imgUrl" alt="">
            </div>
            <!-- 保存按钮 -->
            <div class="saveContainer">
                <mt-button class="save" @click="upload">{{ imgUrl === '' ? '上传' : '修改'}}图片</mt-button>
            </div>
            <input
                style="display: none"
                id="feedBack"
                type="file"
                accept="image/*"
                action="http://192.168.0.1:3000"
                method="post"
                @change="onFileChange"
            />
        </div>
    </div>
</template>

<script>
import UserFetch from '../../fetch/user';
import { userWebService }  from '@/utils/webService';
const webService = userWebService;
//const webService = new UserFetch();

export default {
  props: ['changeImgUrl', 'changeText', 'changeNumber', 'imgUrl'],
  name: 'FeedBackSuggest',
  methods: {
      upload: function() {
          document.getElementById('feedBack').click();
      },
      onFileChange: function(e) {
        const formData = new FormData();
        formData.append('name', e.target.files[0].name);
        formData.append('type', e.target.files[0].type.split('/')[1]);
        formData.append('file', e.target.files[0]);
        webService.upLoadFile(formData)
        .then((response, error) => this.changeImgUrl(`${response.data.host}/${response.data.path}`))
        .catch(err => {
            alert('上传图片出错！');
        });
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filterContent {
    height: fit-content;
    padding: 0 0.15rem;
    line-height: 0.55rem;
    border-bottom: 1px #D8D8D8 solid;
}
.textArea{
    width: calc( 100% - .3rem );
    padding: 0 0.15rem;
}
.textArea textarea {
    height: 1rem;
    width: 100%;
    background-color: #fff;
    margin-bottom: 8px;
    border-radius: 4px;
    outline-style: none ;
    outline-width: 0px ;
    border: 1px solid #009688;
    -webkit-appearance: none;
    font-size: .2rem;
}
.saveContainer {
    padding: 0 0.15rem;
}
.require {
    color: red;
}
.feedBackImg {

}
.feedBackImg img {
    width: 100%;
    height: 100%;
}
.save {
    border-color: #009688;
    color: #009688;
    background: #fff;
    border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/feedBackElement/FeedBackSuggest.vue